import { Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';

import { SiterecordComment } from 'app/models';
import { SiterecordCommentComponent } from 'app/shared/comments/siterecord-comment.component';

@Component({
  selector: 'siterecord-comments',
  templateUrl: './siterecord-comments.component.html',
  styleUrls: ['./siterecord-comments.component.scss']
})
export class SiterecordCommentsComponent implements OnInit {
  @ViewChildren(SiterecordCommentComponent) commentComponents: QueryList<SiterecordCommentComponent>;

  @Input() recentTop = false;
  @Input() canMarkInternal = false;

  @Output() post = new EventEmitter();

  public collapsed = false;

  internalComments: SiterecordComment[] = []; // internal use for this component, not marked 'internal'
  public comment = '';
  public commentAreaTouched = false;
  public internal = false;

  constructor() {}

  public ngOnInit(): void {
    this.comments = this.comments;
    this.sortCommentsByDate(this.recentTop);
  }

  @Input() set comments(value: SiterecordComment[]) {
    this.internalComments = value.slice();
    this.sortCommentsByDate(this.recentTop);
  }
  get comments(): SiterecordComment[] {
    return this.internalComments;
  }

  sortCommentsByDate(recentTop: boolean): void {
    this.internalComments = this.internalComments.sort((ca, cb) => {
      if (recentTop) {
        if (ca.creationDateTime > cb.creationDateTime) {
          return -1;
        } else {
          return 1;
        }
      } else {
        if (ca.creationDateTime > cb.creationDateTime) {
          return 1;
        } else {
          return -1;
        }
      }
    });
  }

  cancelComment(): void {
    this.comment = '';
    this.commentAreaTouched = false;
  }

  postComment(): void {
    const siterecordComment: SiterecordComment = {
      id: null,
      comment: this.comment,
      internal: this.internal,
      creationDateTime: new Date(),
      creationUser: null
    };

    this.post.emit(siterecordComment);
    this.comment = '';
  }

  public collapseAll() {
    this.collapsed = !this.collapsed;
    this.commentComponents.forEach(cc => cc.collapse(this.collapsed));
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/comments/siterecord-comments.component.ts